// extracted by mini-css-extract-plugin
export default {"container":"aSKws","icon":"Nthn7","desktop":"DQnBM","small":"urHHw","tablet":"RwFhb","mobile":"MCqdw","smallMobile":"QlQuf","xsmall":"_zTHx"};